import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import { useState, useEffect } from 'react';
import Navigation from "./Navigation.jsx";
import TestComponent from "./TestComponent.jsx";
import Header from "./Header.jsx";

const TestPage = (props) => {
    let dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    return (<>
        <TestComponent />
        </>
    );
};

export default TestPage;